import { FormikErrors, FormikTouched } from "formik";

export const getClassError = (
  name: string,
  errors: FormikErrors<any>,
  touched: FormikTouched<any>
) => (errors[name] && touched[name] ? "has-error" : "");

export const formatNumber = (num?: number = 0) => (num > 9 ? num : `0${num}`);

export const normalizeText = (text: string) => {
  return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};

export const goToNewOnBoarding = (
  isAdvisor,
  isOwner,
  history,
  urlNewOnboarding,
  urlOldOnBoarding,
  queryParam = false,
  loginParam = false
) => {
  const validateAdvisorOrOwner = isAdvisor || isOwner
  
  if (loginParam) {
    return validateAdvisorOrOwner
        ? (window.location.href = urlNewOnboarding)
        : (window.location.href = urlOldOnBoarding)
  }
  if (queryParam) {
    return validateAdvisorOrOwner
      ? (window.location.href = urlNewOnboarding) 
      : history.push({ pathname: urlOldOnBoarding, search: "?similar=true" })
  }
  return validateAdvisorOrOwner
    ? (window.location.href = urlNewOnboarding)
    : history.push(urlOldOnBoarding)
};

export const filterOptions = (options: any[], term: string) => {
  return term
    ? options.filter(({ label }: any) =>
        normalizeText(label.toLowerCase()).includes(
          normalizeText(term.toLowerCase())
        )
      )
    : options;
};

export const addHotjarScript = (path: string) => {
  if (path.includes('calculadorahomie') || path.includes('inquilino') || path.includes('/h360/registro')){
    const script = window.document.createElement('script');
    script.innerHTML = "(function(h,o,t,j,a,r){ h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)}; h._hjSettings={hjid:235647,hjsv:6}; a=o.getElementsByTagName('head')[0]; r=o.createElement('script');r.async=1; r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv; a.appendChild(r); })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');";
    document.body.appendChild(script);
  }
}